<template>
  <div class="columns account-info-wrapper">
    <div class="column">
      <img src="https://via.placeholder.com/250x400"/>

    </div>
    <div class="column is-two-thirds content">
      <p>
        Fusce pretium mi sit amet tempor tempus. Curabitur ac enim turpis. Maecenas ac malesuada leo. Nulla condimentum velit a lectus vulputate, sed semper est laoreet. Phasellus ultricies neque ut purus commodo, nec dignissim lorem efficitur.
      </p>
      <ul>
        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
        <li>Vivamus volutpat turpis nec lectus fermentum consectetur.</li>
        <li>Proin suscipit nisi quis venenatis interdum.</li>
        <li>Nam eu diam at ipsum pharetra ultrices.</li>
        <li>Cras ac nibh quis mauris pellentesque ullamcorper sit amet et tellus.</li>
        <li>Vivamus in arcu fermentum, interdum nisi non, dictum mi.</li>
      </ul>
    </div>

  </div>
</template>

<script>
import AccountInfo from '../AccountInfo'
import CarrierInfo from '../CarrierInfo'

export default {
  name: 'TrucklEducation',

  components: {
    AccountInfo,
    CarrierInfo
  }
}
</script>

<style scoped lang="scss">
.content-block {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid lightgray;
}
</style>
